<boi-form-outgoings
  [mortgageApplication]="mortgageApplication"
  [isLoanGroupTypeBtlAffordability]="isLoanGroupTypeBtlAffordability()"
  [validationErrors]="mortgageApplicationStore.validationErrors"
></boi-form-outgoings>
